export default {"src":"/_next/static/media/ROIV.d4e2bd18.svg","height":18,"width":18};